module.exports = "/_next/static/images/td-024e1d49b4ee708d5a4eb37a66de6ec7.svg";